import {
  Image,
  MessageBox,
  Message,
  Slider,
  Loading
} from 'element-ui'

const element = {
  install: function(Vue) {
    Vue.use(Image)
    Vue.use(Slider)
    // Vue.use(Loading)

    Vue.prototype.$msgbox = MessageBox;
    Vue.prototype.$alert = MessageBox.alert;
    Vue.prototype.$confirm = MessageBox.confirm;
    Vue.prototype.$prompt = MessageBox.prompt;
    Vue.prototype.$loading = Loading;
    Vue.prototype.$message = Message;
  }
}
export default element

